var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasculino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_538",
    "data-name": "Grupo 538",
    transform: "translate(-876 -763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_150",
    "data-name": "Elipse 150",
    transform: "translate(876 763)",
    fill: "#343131",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-male",
    "data-name": "Icon ionic-md-male",
    d: "M27.26,3.375H18.952V6.49h6.107l-6.925,6.919a9.345,9.345,0,1,0,2.207,2.207L27.26,8.691V14.8h3.115V3.375ZM12.721,27.26a6.231,6.231,0,1,1,6.231-6.231A6.241,6.241,0,0,1,12.721,27.26Z",
    transform: "translate(882.779 769.663)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasculino);
export default __webpack_public_path__ + "static/media/masculino.71f137d82998d369b7e7452cbbf3f36b.svg";
export { ForwardRef as ReactComponent };